import React, { useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import MainMenu from "../components/MainMenu";
import Button from '@material-ui/core/Button';
import SearchList from '../components/SearchList';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import axios from "axios";
import ComFunction from "../components/ComFunction";
import MsgBox from '../components/MsgBox';
import { warnmsg } from '../modules/msgboxstore';
import { resetuser, signinfo } from '../modules/userstore';
import { resetstore, setmenus } from '../modules/menustore';
import { resetenv, setstickys } from '../modules/environstore';
import FormDlg from "../components/FormDialog";
import { isEmpty, customTarget } from '../modules/appLibrary';
import { getAxiosAuthConfig } from '../modules/authToken';
import { persistor } from '../store';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    root: {
        display: 'flex',
        padding: '0 10px',
        height: 30,
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    divider: {
        height: 28,
        margin: 4,
    },
    chip: {
        margin: theme.spacing(0.2),
    },
    snackbarStyleViaContentProps: {
        backgroundColor: "#6ac86f"
    },
    snackbaredittool: {
        backgroundColor: "#F8F8F8",
        color: "#000"
    },
    label: {
        fontSize: "12px"
    },
}));

export const Top = props => {

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const ComFunc = React.forwardRef(ComFunction);
    const [open, setOpen] = React.useState(true);
    const [account, setaccount] = React.useState("");
    const [password, setpassword] = React.useState("");
    const [menuopen, setmenuopen] = React.useState(false);
    const fnc = useRef();

    const corpkey = useSelector(state => state.user.corpkey);
    const loginkey = useSelector(state => state.user.loginkey);
    const classes = useStyles();

    useEffect(() => {
        if (!isEmpty(location.hash)) {  //menu完全削除から起動
            setmenuopen(true);
        }
        if (!isEmpty(loginkey)) {      //クエリパラメータKEYログイン
            setmenuopen(true);
        }
    }, []);

    function handleChange(event) {
        if (event.target.name === "code")
            setaccount(event.target.value);
        else
            setpassword(event.target.value);
    };

    function relogin() {
        setmenuopen(false);
        setOpen(true);
    }
    async function signin() {
        try {
            //sign in
            let param = new FormData();
            param.append('corpkey', corpkey);
            param.append('account', account);
            param.append('password', password);
            const res = await axios.post('login/signin', param, getAxiosAuthConfig());
            const data = res.data;
            if (data.status) {
                let info = {
                    account: account, name: data.returnData["name"], authority: data.returnData["admin"],
                    role: data.returnData["role"], staff: data.returnData["staff"], accctl:data.data
                };
                dispatch(signinfo(info));
            } else {
                dispatch(warnmsg(data.errDescription));
                return;
            }
            //get menu
            param.append('role', data.returnData["role"]);
            const res2 = await axios.post('menu/getmenu', param, getAxiosAuthConfig());
            const menudata = res2.data;
            if (data.status) {
                let menu = {
                    category: menudata.category,
                    menus: menudata.menus,
                    menudefs: menudata.menudefs,
                    original:menudata.original,
                    menucolors: menudata.colors,
                    recievemsg: menudata.recievemsg,
                    sendmsg: menudata.sendmsg,
                    washmark: menudata.washmark,
                    dashboard: menudata.dashboard
                };
                dispatch(setmenus(menu));
                dispatch(setstickys({ stickys: menudata.stickys, stickycolor: menudata.stickycolor }));
            } else {
                dispatch(warnmsg(data.errDescription));
                return;
            }
            //dialog close
            setOpen(false);
            setmenuopen(true);

        } catch (error) {
            const { status, statusText } = error.response;
            console.log(`Error! HTTP Status: ${status} ${statusText}`);
        }
    }

    function logout () {
        setOpen(false);
        dispatch(resetuser());
        dispatch(resetstore());
        dispatch(resetenv());
        persistor.purge();
        history.push('/')
    };

    return (
        <div>
            <MainMenu
                show={menuopen}
                isTop={true}
                doClose={relogin}
                fnc={fnc}
            />

            <SearchList inTag={false} />
            <div>
                <Dialog open={open} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Sign in</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            name="code"
                            label="accountcode"
                            type="text"
                            fullWidth
                            onChange={handleChange}
                        />
                        <TextField
                            margin="dense"
                            name="password"
                            label="password"
                            type="password"
                            fullWidth
                            onChange={handleChange}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={signin} color="primary">Sign In</Button>
                        <Button onClick={logout} color="primary">LOGOUT</Button>
                    </DialogActions>
                </Dialog>
            </div>
            <MsgBox />
            <FormDlg classes={classes} fnc={fnc} />
            <ComFunc ref={fnc} />
        </div>
    );
};

